import { IColumn, Stack, Text } from '@fluentui/react';
import { WorkgroupGroupRow } from '.';
import { EditWorkgroupGroup } from '../view/EditWorkgroupGroup';
import { WorkgroupGroupItem } from './WorkgroupGroupItem';

export type ColumnStylesProps = {
  onRenderColumnStack: string;
};

export const onRenderItems = (styles: ColumnStylesProps) => {
  const renderItemColumn = (
    item: WorkgroupGroupRow,
    _index: number | undefined,
    column: IColumn | undefined
  ) => {
    if (item) {
      const fieldContent = item[
        column?.fieldName as keyof WorkgroupGroupRow
      ] as string;
      switch (column?.key) {
        case 'action':
          return (
            <Stack
              horizontal
              verticalAlign="center"
              horizontalAlign="center"
              tokens={{ childrenGap: 3 }}
            >
              <EditWorkgroupGroup workgroupGroup={item} />
            </Stack>
          );
        case 'workgroupGroupItems':
          return (
            <Stack wrap horizontal tokens={{ childrenGap: 10 }}>
              {item.workgroupGroupItems.nodes.map((groupItem, index) => (
                <Stack key={index}>
                  <WorkgroupGroupItem item={groupItem} />
                </Stack>
              ))}
            </Stack>
          );
        default:
          return (
            <Stack
              verticalAlign="center"
              className={styles.onRenderColumnStack}
            >
              <Text>{fieldContent}</Text>
            </Stack>
          );
      }
    }
  };
  return renderItemColumn;
};
